var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8774 4.27414C21.2225 0.596778 11.1737 0.82993 4.97192 4.32943C2.14439 5.92187 0.853725 7.94726 0.609375 10.0193C1.3872 8.6351 2.74992 7.32152 4.69422 6.22451C11.1816 2.56687 21.6994 2.56687 28.1859 6.22451C30.1097 7.30936 31.4621 8.60801 32.2447 9.97467C32.0107 7.91887 30.7165 5.8428 27.8774 4.27414Z",
    fill: "url(#paint0_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.129 22.2512C15.129 22.2512 9.44464 20.2164 4.69567 17.4352C1.57588 15.6059 -0.0402232 13.2899 -0.136968 10.9729L-0.145629 10.9082L-0.169216 12.7672C-0.208836 15.193 1.41998 17.6145 4.69567 19.4749C10.4539 22.7452 14.5603 23.7325 14.5603 23.7325L15.3238 22.3642L15.129 22.2512Z",
    fill: "url(#paint1_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9906 10.9492C32.876 13.2461 31.2634 15.5548 28.1865 17.4369C21.9738 21.2376 18.3128 22.3818 17.04 22.6962L17.4042 24.4763C17.4042 24.4763 23.1523 22.5005 28.1865 19.4778C31.3892 17.5556 33.0118 15.3544 33.0005 12.949L32.9821 11.1709L32.9906 10.9492Z",
    fill: "url(#paint2_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26399 21.793C9.35079 21.8346 9.44827 21.8746 9.5347 21.9132V19.93C9.44256 19.8883 9.35521 19.8489 9.26399 19.8054V21.793ZM8.14747 21.2769C8.23868 21.3204 8.32787 21.3619 8.41725 21.4045V19.4045C8.32787 19.361 8.23868 19.3164 8.14747 19.2727V21.2769ZM10.3825 22.2746C10.476 22.3131 10.5611 22.3483 10.6523 22.3852V20.4352C10.5631 20.3955 10.4728 20.3561 10.3825 20.3145V22.2746ZM5.91331 20.1478C6.00452 20.1985 6.09279 20.2442 6.18401 20.2918V18.2666C6.09482 18.2177 6.00342 18.1702 5.91331 18.1191V20.1478ZM7.02873 20.7286C7.12087 20.7762 7.21043 20.8208 7.29961 20.8646V18.8508C7.21043 18.8042 7.11921 18.7565 7.02873 18.7108V20.7286ZM4.79567 19.533C4.88689 19.5857 4.97516 19.6343 5.06638 19.685V17.6467C4.97626 17.595 4.88486 17.5443 4.79567 17.4916V19.533ZM0.112305 14.573C0.181777 14.7992 0.283681 15.0349 0.382084 15.2485V13.1031C0.275573 12.8622 0.186384 12.6495 0.112305 12.4062V14.573ZM2.56041 17.9947C2.64389 18.0684 2.74468 18.1499 2.83129 18.22V16.1313C2.74008 16.0558 2.64702 15.9822 2.56041 15.9063V17.9947ZM3.67712 18.8444C3.76318 18.9023 3.8496 18.9655 3.94782 19.0235V16.9539C3.85955 16.8962 3.76355 16.8404 3.67712 16.7796V18.8444ZM1.58485 17.0453C1.67202 17.1428 1.76139 17.2368 1.85574 17.3332V15.2321C1.75733 15.1281 1.67607 15.0212 1.58485 14.9158V17.0453ZM0.758376 15.9406C0.847565 16.0871 0.925698 16.2012 1.02816 16.3451V14.2051C0.932701 14.0652 0.842774 13.9245 0.758376 13.7832V15.9406ZM11.4991 22.7232C11.5885 22.7579 11.6834 22.7943 11.7689 22.8259V20.9201C11.6806 20.8816 11.5905 20.8419 11.4991 20.8034V22.7232ZM12.6543 21.2902V23.1466C12.7435 23.1781 12.8367 23.2111 12.9221 23.2387V21.3997C12.8349 21.363 12.7446 21.3274 12.6543 21.2893V21.2902Z",
    fill: "url(#paint3_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1576 23.422C20.2428 23.3876 20.3382 23.3483 20.4274 23.3115V21.51C20.334 21.5496 20.2488 21.5837 20.1576 21.6215V23.422ZM19.0391 23.8686C19.1262 23.8353 19.2174 23.8001 19.3098 23.7626V21.9605C19.2134 21.9973 19.1303 22.0264 19.0391 22.0598V23.8686ZM21.273 22.9554C21.3698 22.9185 21.4505 22.8787 21.5428 22.8391V21.0161C21.4527 21.0586 21.3613 21.1012 21.273 21.1408V22.9554ZM22.3907 22.4653C22.481 22.4258 22.5703 22.3846 22.6616 22.3429V20.4886C22.5744 20.5311 22.4749 20.584 22.3907 20.6246V22.4653ZM31.839 16.3395C31.9404 16.198 32.0217 16.0793 32.1109 15.9363V13.7037C32.0253 13.8471 31.9347 13.9891 31.839 14.1297V16.3395ZM32.4739 12.9897V15.2313C32.5782 15.0112 32.6686 14.7847 32.7446 14.5532V12.2578C32.67 12.5074 32.5794 12.7518 32.4733 12.9897H32.4739ZM31.1252 17.196C31.2245 17.0906 31.3035 17.0053 31.3948 16.8987V14.718C31.3056 14.8277 31.2214 14.9371 31.1252 15.0451V17.196ZM24.6265 21.412C24.7157 21.3683 24.806 21.3227 24.8952 21.2781V19.3313C24.806 19.3788 24.7146 19.4317 24.6265 19.4772V21.412ZM27.9792 17.5582V19.6017C28.0481 19.5602 28.1181 19.52 28.1861 19.4784C28.2084 19.4651 28.2276 19.4529 28.2499 19.4398V17.3949C28.2276 17.408 28.2084 17.4233 28.1861 17.4375C28.1135 17.4812 28.0516 17.5156 27.9787 17.5582H27.9792ZM29.0978 18.8945C29.1871 18.8347 29.282 18.7665 29.3675 18.7057V16.6352C29.2804 16.7001 29.1881 16.7629 29.0978 16.828V18.8945ZM30.2145 18.0505C30.3108 17.9703 30.3949 17.8964 30.4861 17.8153V15.6917C30.3919 15.7796 30.3118 15.8692 30.2145 15.9554V18.0505ZM25.745 20.843C25.8342 20.7954 25.9218 20.756 26.0148 20.7011V18.7175C25.9216 18.7728 25.8374 18.8159 25.745 18.8666V20.843ZM26.8616 20.2421C26.9508 20.1914 27.0387 20.15 27.1314 20.0914V18.0603C27.0412 18.113 26.9508 18.1668 26.8616 18.2184V20.2421ZM23.5078 21.952C23.5971 21.9114 23.6894 21.8674 23.7786 21.823V19.9297C23.6834 19.9804 23.6012 20.018 23.5078 20.0656V21.952Z",
    fill: "url(#paint4_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.186 4.18728C21.6994 0.528719 11.1817 0.528719 4.69429 4.18728C-1.79314 7.84584 -1.72735 13.6713 4.69558 17.4366C9.44381 20.2179 15.1282 22.2526 15.1282 22.2526L16.5174 22.8094C16.5174 22.8094 20.3083 22.2526 28.1852 17.4366C34.5365 13.5543 34.6734 7.84547 28.186 4.18728ZM27.6737 16.9841C22.8993 19.9106 16.0131 22.4382 16.0131 22.4382L15.4451 21.6988C15.4451 21.6988 9.06513 19.229 5.20934 16.9841C-0.942338 13.3995 -0.995042 7.81266 5.20842 4.31537C11.4119 0.818087 21.4693 0.815875 27.6737 4.31537C33.878 7.81487 33.7415 13.2657 27.6737 16.9841Z",
    fill: "url(#paint5_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1818 27.1983L13.4385 25.6513V21.7441L16.1818 23.29V27.1983Z",
    fill: "url(#paint6_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6148 26.5327L13.7266 25.4667V22.5625L15.6148 23.6287V26.5327Z",
    fill: "url(#paint7_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6726 20.4824L13.4385 21.7433L16.1818 23.2891V27.1974L18.416 25.9375V22.0293L15.6726 20.4824Z",
    fill: "url(#paint8_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.416 22.0293L15.6726 20.4824L13.4385 21.7433L16.1818 23.2891L18.416 22.0293Z",
    fill: "#EFEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6148 23.627C10.5603 25.6398 3.72402 30.3336 3.72402 30.3336C3.24029 30.6055 2.84668 31.3389 2.84668 31.9668C2.84668 32.5948 3.24029 32.4991 3.72402 32.2248C3.72402 32.2248 10.6251 27.7181 15.6148 25.52V23.627Z",
    fill: "url(#paint9_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.407 27.6307C11.4983 27.5811 11.5865 27.5305 11.6766 27.4816V25.4911C11.5865 25.5388 11.4983 25.5886 11.407 25.6352V27.6307ZM8.05433 29.5459C8.14352 29.493 8.23474 29.4403 8.32503 29.3855V27.4037C8.23474 27.459 8.14352 27.512 8.05433 27.5668V29.5459ZM6.9367 30.2159C7.02386 30.1632 7.1171 30.1079 7.2074 30.052V28.0841C7.11931 28.1394 7.02312 28.1967 6.9367 28.25V30.2159ZM9.17178 28.8916C9.26207 28.8389 9.35126 28.7862 9.44266 28.7335V26.7442C9.35052 26.7969 9.26207 26.8498 9.17178 26.9025V28.8916ZM5.8198 30.9009C5.90899 30.8457 5.99523 30.7935 6.08958 30.7351V28.783C5.99523 28.8439 5.91102 28.8997 5.8198 28.9565V30.9009ZM4.69922 31.603C4.78749 31.5477 4.87262 31.4924 4.97084 31.4314V29.5042C4.87262 29.5693 4.78657 29.625 4.69922 29.6828V31.603ZM13.641 26.4541C13.7321 26.4095 13.8203 26.3669 13.9117 26.3223V24.3738C13.8196 24.4153 13.7321 24.4549 13.641 24.4995V26.4541ZM14.7572 23.986V25.9124C14.8475 25.8689 14.9357 25.8265 15.027 25.786V23.8691C14.9363 23.9077 14.848 23.9464 14.7572 23.986ZM12.5226 27.0323C12.6128 26.9847 12.7031 26.937 12.7924 26.8892V24.9184C12.7031 24.9641 12.6128 25.0087 12.5226 25.0554V27.0323ZM10.2883 28.2515C10.3786 28.2008 10.4669 28.1501 10.5581 28.1004V26.1021C10.4659 26.1518 10.3786 26.2071 10.2883 26.2587V28.2515Z",
    fill: "url(#paint10_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84583 31.9661C2.84583 31.3382 3.23945 30.6048 3.72317 30.333C3.72317 30.333 10.5598 25.6386 15.6139 23.6263L15.0543 23.3105C10.0022 25.3241 3.16426 30.0165 3.16426 30.0165C2.67851 30.2893 2.28711 31.0217 2.28711 31.6515C2.28711 32.2299 2.81322 32.5318 3.28478 32.4182C2.98257 32.4081 2.84583 32.3694 2.84583 31.9661Z",
    fill: "url(#paint11_linear_654_197)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.7266 22.5625L14.2809 23.6361L14.7366 23.4426L15.268 23.7697L15.2721 25.6757L15.1142 25.7478L15.6148 26.5327V23.6287L13.7266 22.5625Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.9808 11.1706L32.9833 11.1087C33.1822 8.61036 31.6033 6.11387 28.1859 4.18728C21.6994 0.528719 11.1817 0.528719 4.69423 4.18728C1.37726 6.05803 -0.225936 8.49609 -0.142275 10.9354L-0.145776 10.9096L-0.169363 12.7686C-0.178151 13.3815 -0.0831986 13.9914 0.111473 14.5726C0.168721 14.7524 0.236404 14.9287 0.314176 15.1007C0.335552 15.1495 0.357481 15.1983 0.380332 15.247V15.2481C0.492286 15.4858 0.617927 15.7167 0.756623 15.9398C0.84268 16.081 0.918417 16.1923 1.01461 16.3291L1.02014 16.337L1.02548 16.3444C1.19856 16.5862 1.38439 16.8187 1.58218 17.0407V17.0448C1.66934 17.1423 1.75871 17.2363 1.85306 17.3327C2.07186 17.5587 2.30829 17.7807 2.56234 17.9986C2.6449 18.0723 2.74293 18.151 2.82862 18.2197C3.09324 18.4328 3.37518 18.6411 3.67445 18.8446L3.67776 18.8468C3.76253 18.9039 3.84785 18.9662 3.94459 19.0233C4.18378 19.1775 4.43329 19.3286 4.69312 19.4764L4.79245 19.5328C4.88366 19.5855 4.97193 19.6341 5.06315 19.6848C5.34988 19.8446 5.63244 19.9988 5.91082 20.1476C6.00203 20.1983 6.0903 20.244 6.18152 20.2916C6.4685 20.4431 6.75007 20.5887 7.02624 20.7284C7.11838 20.7759 7.20793 20.8205 7.29712 20.8644C7.58631 21.0087 7.86887 21.1464 8.14479 21.2776L8.15898 21.2843C8.24092 21.3233 8.32219 21.3617 8.40278 21.3995L8.41457 21.4052C8.70499 21.5413 8.98724 21.6703 9.26132 21.7922C9.34811 21.8339 9.4456 21.8739 9.53202 21.9124C9.82514 22.0412 10.1077 22.1621 10.3797 22.2751L10.4134 22.2889L10.4534 22.3057C10.5192 22.333 10.5824 22.3595 10.6495 22.3863C10.9463 22.5075 11.2288 22.6194 11.4971 22.7219C11.5865 22.7565 11.6814 22.793 11.7669 22.8246C12.0863 22.9447 12.3812 23.0516 12.6514 23.1453C12.7406 23.1768 12.8339 23.2098 12.9192 23.2374C13.1061 23.3006 13.278 23.3572 13.4352 23.4073V24.0156C8.65708 26.2468 3.16179 30.0182 3.16179 30.0182C2.67604 30.291 2.28464 31.0234 2.28464 31.6532C2.28464 32.1986 2.7527 32.4981 3.20159 32.435C3.22866 32.4318 3.2555 32.4268 3.28194 32.4201C3.41093 32.388 3.56075 32.3169 3.72033 32.2266C3.72033 32.2266 4.08022 31.9916 4.69497 31.6027V31.6038C4.78323 31.5485 4.86837 31.4932 4.96659 31.4322C5.21868 31.2737 5.50338 31.0958 5.81555 30.9025C5.90474 30.8472 5.99098 30.7951 6.08533 30.7366C6.35216 30.5722 6.63613 30.3984 6.93465 30.2174C7.0209 30.1653 7.11285 30.1109 7.20204 30.0558C7.47489 29.891 7.75781 29.7216 8.05081 29.5476C8.14 29.4947 8.23122 29.442 8.32151 29.3873C8.59731 29.2244 8.87956 29.0592 9.16826 28.8919V28.8939C9.25856 28.8412 9.34775 28.7885 9.43915 28.7358C9.71703 28.576 9.99892 28.4152 10.2848 28.2534C10.3751 28.2027 10.4634 28.152 10.5546 28.1023V28.101C10.8357 27.9436 11.1186 27.7869 11.4035 27.631V27.6327C11.4616 27.6011 11.5185 27.5691 11.5755 27.5374C11.8895 27.3667 12.204 27.1984 12.5191 27.0324V27.0342C12.6092 26.9867 12.6995 26.9389 12.7889 26.8912C13.1143 26.7216 13.4379 26.5566 13.7595 26.3961L13.9069 26.3242V26.3228C14.0352 26.2594 14.1628 26.1968 14.2898 26.1351L16.1776 27.1997L18.4117 25.9398V24.1088C18.5978 24.0386 18.8066 23.9588 19.0355 23.8692C19.1227 23.8359 19.2139 23.8007 19.3062 23.7632C19.6082 23.6442 19.9394 23.5113 20.2947 23.3651L20.4236 23.3121C20.6931 23.2015 20.9765 23.0819 21.2693 22.9562C21.366 22.9193 21.4467 22.8795 21.5391 22.8399C21.8136 22.7209 22.0962 22.5963 22.3867 22.4661C22.477 22.4266 22.5664 22.3853 22.6576 22.3437C22.9343 22.2182 23.2162 22.0879 23.5033 21.9528C23.5926 21.9122 23.685 21.8682 23.7741 21.8237C24.0535 21.6907 24.3361 21.5534 24.6218 21.412C24.711 21.3683 24.8013 21.3228 24.8905 21.2782C25.1721 21.137 25.4554 20.992 25.7404 20.843L25.7573 20.8342L25.778 20.8235C25.8543 20.7841 25.9302 20.7483 26.0102 20.7011C26.2927 20.5516 26.575 20.3985 26.8569 20.242L26.8613 20.2394L26.8982 20.2193C26.9737 20.178 27.0487 20.1403 27.1274 20.0912C27.4114 19.9315 27.694 19.7683 27.9751 19.6017C28.044 19.5602 28.114 19.5201 28.182 19.4784C28.2043 19.4651 28.2235 19.453 28.2458 19.4399C28.5422 19.2604 28.8248 19.0786 29.0935 18.8945C29.1828 18.8348 29.2777 18.7666 29.3632 18.7058C29.6642 18.4905 29.9468 18.2721 30.2109 18.0505C30.3073 17.9704 30.3913 17.8965 30.4825 17.8154C30.7479 17.5786 30.9924 17.3386 31.2161 17.0953C31.2755 17.0311 31.3307 16.9698 31.3912 16.899C31.5509 16.7147 31.699 16.5281 31.8355 16.3392L31.8552 16.3116C31.8683 16.2931 31.8812 16.2747 31.8941 16.2563C31.9035 16.243 31.9125 16.2299 31.9217 16.2168C31.9309 16.2038 31.9401 16.1898 31.9499 16.1761C32.0035 16.098 32.054 16.0211 32.1073 15.9365C32.7034 14.9829 32.9998 13.9876 32.9966 12.9507L32.9808 11.1706ZM2.84668 31.9977C2.84693 32.071 2.85647 32.1439 2.87506 32.2148C2.85555 32.144 2.846 32.0709 2.84668 31.9975V31.9977ZM27.6736 16.9841C24.441 18.9655 20.2408 20.764 17.8648 21.7191L15.6719 20.4827L14.3147 21.2485C12.3081 20.4346 8.06574 18.6481 5.20873 16.9841C1.86338 15.0349 0.321916 12.4934 0.609202 10.0172C1.38758 8.63377 2.7503 7.31963 4.69423 6.22354C11.1817 2.5659 21.6994 2.5659 28.1859 6.22354C30.1094 7.30821 31.4618 8.60667 32.2448 9.9737C32.5186 12.4272 30.9732 14.9622 27.6736 16.9841Z",
    fill: "#020300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_654_197",
    x1: 0.609375,
    y1: 5.81423,
    x2: 32.2449,
    y2: 5.81423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_654_197",
    x1: 18.9848,
    y1: 17.3207,
    x2: -1.4785,
    y2: 17.3207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_654_197",
    x1: 36.7201,
    y1: 17.7129,
    x2: 16.8541,
    y2: 17.7129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_654_197",
    x1: 0.112305,
    y1: 17.8218,
    x2: 12.9221,
    y2: 17.8218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_654_197",
    x1: 19.0391,
    y1: 18.0632,
    x2: 32.744,
    y2: 18.0632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_654_197",
    x1: 16.4273,
    y1: 25.9339,
    x2: 16.4273,
    y2: 20.0656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_654_197",
    x1: 19.9617,
    y1: 21.1424,
    x2: 14.0815,
    y2: 24.9406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_654_197",
    x1: 12.4847,
    y1: 25.6099,
    x2: 15.1072,
    y2: 24.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575756"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_654_197",
    x1: 16.3978,
    y1: 23.9051,
    x2: 20.2373,
    y2: 26.9213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_654_197",
    x1: 17.412,
    y1: 28.0323,
    x2: 10.8717,
    y2: 28.0323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_654_197",
    x1: 8.65525,
    y1: 27.7362,
    x2: 15.7355,
    y2: 27.7362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_654_197",
    x1: 4.67403,
    y1: 35.1363,
    x2: 6.68414,
    y2: 31.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    fill: "white",
    transform: "translate(0 0.443359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD15);
export default __webpack_public_path__ + "static/media/d15.e70975a7f2f4420f124cc4cc2fdb1ba0.svg";
export { ForwardRef as ReactComponent };